export default __webpack_public_path__ + "assets/fiji-flag.png";